var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tooltip-btn',{attrs:{"href":"https://github.com/vuetifyjs/vuetify","icon":"$mdiGithub","path":"github","rel":"noopener","target":"_blank"},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }